import { Plugin } from 'ckeditor5';
import { PlaceholderToolbar } from './toolbar';
import { PlaceholderWidget } from './widget';
/**
 * This plugin adds support for creating placeholders in the editor.
 */
export class PlaceholderEditing extends Plugin {
    static get pluginName() {
        return 'PlaceholderEditing';
    }
    static get requires() {
        return [PlaceholderToolbar, PlaceholderWidget];
    }
}
